// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"c1f1fb29","161":"34405131","300":"c5a57ac2","312":"cb8df463","320":"c9db62de","682":"e1027d38","708":"9b45ab93"}[chunkId] + ".chunk.js";
};